import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sfx-numeric-selector column items-center" }

import { QIcon } from "quasar"
import SfxInput from "src/components/input/SfxInput.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { computed } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxNumericSelector',
  props: {
  modelValue: {
    type: Number,
  },

  min: {
    type: Number,
    default: 0,
  },

  max: {
    type: Number,
    default: 999,
  },

  hideArrows: {
    type: Boolean,
    default: false,
  },

  disable: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

// endregion

// region Variables

const count = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    return emit("update:modelValue", value)
  },
})

const isIncrementDisabled = computed(
  () => (count.value !== undefined && count.value >= props.max) || props.disable
)
const isDecrementDisabled = computed(
  () => (count.value !== undefined && count.value <= props.min) || props.disable
)

// endregion

// region Functions

function handleIncrement() {
  if (count.value === undefined) {
    count.value = 1
  } else if (!isIncrementDisabled.value) {
    count.value++
  }
}

function handleDecrement() {
  if (count.value === undefined) {
    count.value = 1
  } else if (!isDecrementDisabled.value) {
    count.value--
  }
}

function validateInput() {
  const num = Number(count.value)
  if (Number.isNaN(num)) {
    count.value = props.modelValue
  } else {
    if (num > props.max) {
      count.value = props.max
    } else if (num < props.min) {
      count.value = props.min
    } else {
      count.value = num
    }
  }
}

// endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.hideArrows)
      ? (_openBlock(), _createBlock(_unref(QIcon), {
          key: 0,
          name: _unref(Icons).CHEVRON_UP,
          onClick: handleIncrement,
          class: _normalizeClass(`arrow-icon arrow-up col ${isIncrementDisabled.value ? ' disabled' : ''}`)
        }, null, 8, ["name", "class"]))
      : _createCommentVNode("", true),
    _createVNode(SfxInput, {
      modelValue: count.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((count).value = $event)),
      onBlur: validateInput,
      type: "number",
      disable: props.disable,
      class: "no-padding-input"
    }, null, 8, ["modelValue", "disable"]),
    (!props.hideArrows)
      ? (_openBlock(), _createBlock(_unref(QIcon), {
          key: 1,
          name: _unref(Icons).CHEVRON_DOWN,
          onClick: handleDecrement,
          class: _normalizeClass(`arrow-icon arrow-down col ${isDecrementDisabled.value ? 'disabled' : ''}`)
        }, null, 8, ["name", "class"]))
      : _createCommentVNode("", true)
  ]))
}
}

})